import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { AppShell } from '@/components/layout/app-shell'
import { ensureSession } from '@/lib/api'
import { needsTwoFactorEnrollment, useAuthStore } from '@/lib/auth'
import { ROUTES } from '@/lib/routes'

/** Layout de las pantallas autenticadas. */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ location }) => {
    const ok = await ensureSession()
    if (!ok) throw redirect({ to: ROUTES.login, search: { redirect: location.href } })
    const employee = useAuthStore.getState().employee
    if (employee?.mustChangePassword) throw redirect({ to: ROUTES.changePassword })
    // La política exige el segundo factor a su rol: sin activarlo no puede usar la aplicación.
    if (needsTwoFactorEnrollment(employee)) throw redirect({ to: ROUTES.twoFactorSetup })
  },
  component: AppLayout,
})

function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}
